import { Middleware } from '@reduxjs/toolkit';

import {
  confirmPayment,
  initiateConfirmation,
  updateConfirmationPayloadItem,
  uploadFile,
  uploadFileSuccess,
} from '@cashier/cashier-data-access';
import { FormPayload, ValidationStatuses } from '@cashier/cashier-model';

import { PaymentAttributesMapper } from '../services/common';

export const paymentConfirmationMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    if (action.type === initiateConfirmation.toString()) {
      const {
        confirmationForm: { formPayload, formSchema },
        paymentProcessing: {
          result: { transactionId },
        },
      } = store.getState();

      const fileUploadField = formSchema.fileUploadField;
      const paymentAttributes = PaymentAttributesMapper.fromPayload(
        formPayload as FormPayload,
      );

      if (fileUploadField && !paymentAttributes[fileUploadField.name]) {
        const {
          fileUploading: { data },
        } = store.getState();

        data && store.dispatch(uploadFile(data, transactionId));
      } else {
        store.dispatch(
          confirmPayment({
            transactionId: transactionId,
            paymentAttributes,
          }),
        );
      }
    }

    if (action.type === uploadFileSuccess.toString()) {
      const {
        confirmationForm: { formSchema },
      } = store.getState();

      const fileUploadField = formSchema.fileUploadField;

      if (fileUploadField) {
        store.dispatch(
          updateConfirmationPayloadItem({
            name: fileUploadField.name,
            fieldPayload: {
              value: action.payload.link,
              interactionCompleted: true,
              validationStatus: ValidationStatuses.SUCCESS,
              errors: [],
            },
          }),
        );
      }

      store.dispatch(initiateConfirmation());
    }

    return result;
  };
